import { VariablesConstant } from "../../constants/variables";

export default function NotificationItem(props: any) {
  return (
    <>
      {props.notiTp === VariablesConstant.COLLECTION_INSTANCE_STOPPED && (
        <span>
          <b>Collection instance</b> of connection <b>{props.connNm}</b> has stopped.
        </span>
      )}
      {props.notiTp === VariablesConstant.DELIVERY_INSTANCE_STOPPED && (
        <span>
          <b>Delivery instance</b> of connection <b>{props.connNm}</b> has stopped.
        </span>
      )}
      {props.notiTp === VariablesConstant.COLLECTION_CONNECT_KAFKA_FAILED && (
        <span>
          <b>Collection instance</b> of connection <b>{props.connNm}</b> can't connect to kafka.
        </span>
      )}
      {props.notiTp === VariablesConstant.DELIVERY_CONNECT_KAFKA_FAILED && (
        <span>
          <b>Delivery instance</b> of connection <b>{props.connNm}</b> can't connect to kafka.
        </span>
      )}
      {props.notiTp === VariablesConstant.COLLECTION_DEVICE_STOPPED && (
        <span>
          <b>Collection instance</b> of connection <b>{props.connNm}</b> can't connect to device.
        </span>
      )}
      {props.notiTp === VariablesConstant.DELIVERY_CONNECT_DATABASE_FAILED && (
        <span>
          <b>Delivery instance</b> of connection <b>{props.connNm}</b> can't connect to database.
        </span>
      )}
      
    </>
  );
}
